module.exports = __webpack_public_path__ + "img/story3.a690475d.webp";